export default "__VITE_ASSET__CeJAEk9a__"